import config from 'SRC/config/config.yaml'

export const profileMenu = config.sidebar.profile.menu

profileMenu[Symbol.iterator] = function * () {
  for (const itemKey in profileMenu) {
    yield profileMenu[itemKey]
  }
}
